import { render, staticRenderFns } from "./NoAccessView.vue?vue&type=template&id=46453f00&scoped=true&"
import script from "./NoAccessView.vue?vue&type=script&lang=js&"
export * from "./NoAccessView.vue?vue&type=script&lang=js&"
import style0 from "./NoAccessView.vue?vue&type=style&index=0&id=46453f00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46453f00",
  null
  
)

export default component.exports